import React, { Component } from 'react';
import { translate } from "react-translate";

import MenuComponent from '../MenuComponent';
import FooterComponent from '../FooterComponent'


import {
  Segment,
  Image,
  Container,
  Header,
  Grid,
} from 'semantic-ui-react';

import './partenaire.css'
import image_hero from '../../../assets/img/partenaire.png';
import partenaire1 from '../../../assets/img/partenaire1.png';
import partenaire2 from '../../../assets/img/partenaire2.png';
import partenaire3 from '../../../assets/img/partenaire3.png';
import partenaire4 from '../../../assets/img/partenaire4.png';
import btn from '../../../assets/img/button.png';

class PartenaireComponent extends Component {
  render() {
    const { t } = this.props;
    return (
      <div>
            <MenuComponent />

            <Segment vertical id="sectionPartenaire">
                <Image
                    src={image_hero}
                    id="sectionPartenaireImage"
                    fluid
                    style={{maxHeight: "300px"}}/>
                <div id="containerPartenaire">
                    <Container textAlign='center'>
                        <Header size='huge' as='h1' id="containerPartenaireTitre">{t("Segment1_title")}</Header>
                    </Container>

                    <Container textAlign='center'>
                        <p id="containerPartenaireDescription">
                            {t("Segment1_description")}
                        </p>
                    </Container>
                </div>
            </Segment>

            <Segment vertical style={{border:'none'}} >
                <Grid centered stackable columns={2} padded>
                    <Grid.Row>
                        <Grid.Column textAlign="middle" textAlign='center' id="columnPartenaire1" mobile={16} tablet={8} computer={7}>
                            <Image src={partenaire1} id="fonctionImage" fluid />
                            <div id="containerPartenaireImage">
                                <Container textAlign='left' id="sectionPartenaireContainer">
                                    <Header as='h3' size="huge" id="containerPartenaireImageTitle">{t("Segment2_titreimage_1")}</Header>
                                    <Header as='p' id="containerPartenaireImageDescription">{t("Segment2_description_1")}</Header>
                                </Container>
                            </div>
                        </Grid.Column>
                        <Grid.Column textAlign="middle" textAlign='center'  id="columnPartenaire" mobile={16} tablet={8} computer={7}>
                            <Image src={partenaire2} id="fonctionImage" fluid />
                            <div id="containerPartenaireImage">
                                <Container textAlign='left' id="sectionPartenaireContainer">
                                    <Header as='h3' size="huge" id="containerPartenaireImageTitle">{t("Segment2_titreimage_2")}</Header>
                                    <Header as='p' id="containerPartenaireImageDescription">{t("Segment2_description_2")}</Header>
                                </Container>
                            </div>
                        </Grid.Column>
                    </Grid.Row>
                    <Grid.Row>
                        <Grid.Column  textAlign="middle" textAlign='center' id="columnPartenaire1" mobile={16} tablet={8} computer={7}>
                            <Image src={partenaire3} id="fonctionImage" fluid />
                            <div id="containerPartenaireImage">
                                <Container textAlign='left' id="sectionPartenaireContainer">
                                    <Header as='h3'size="huge"  id="containerPartenaireImageTitle">{t("Segment2_titreimage_3")}</Header>
                                    <Header as='p' id="containerPartenaireImageDescription">{t("Segment2_description_3")}</Header>
                                </Container>
                            </div>
                        </Grid.Column>
                        <Grid.Column  textAlign="middle" textAlign='center'  id="columnPartenaire" mobile={16} tablet={8} computer={7}>
                            <Image src={partenaire4} id="fonctionImage" fluid />
                            <div id="containerPartenaireImage">
                                <Container textAlign='left' id="sectionPartenaireContainer">
                                    <Header as='h3'size="huge"  id="containerPartenaireImageTitle">{t("Segment2_titreimage_4")}</Header>
                                    <Header as='p' id="containerPartenaireImageDescription">{t("Segment2_description_4")}</Header>
                                </Container>
                            </div>
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
            </Segment>

            <br/>

            <Grid verticalAlign={"middle"} >
                <Grid.Row verticalAlign={"middle"} textAlign={"center"} >
                    <Grid.Column>
                        <Container>
                            <Header as="h1" id="thirdSectionPartenaireTitle" >{t('Segment3_titre')}</Header>
                        </Container>
                    </Grid.Column>
                </Grid.Row>
            </Grid>

            <Segment vertical textAlign="center" id="thirdSectionPartenaire">
                <Container>
                    <Grid centered stackable columns={2}>
                        <Image src={btn} id="button" fluid />
                        <div id="thirdSectionPartenaireContainerImage">
                            <Header as='a' id="btnText">{t("Segment4_contact")}</Header>
                        </div>
                        <div id="thirdSectionPartenaireContainerImage2">
                            <Header as='a' id="btnText">{t("Segment4_mail")}</Header>
                        </div>
                    </Grid>
                </Container>
            </Segment>

            <FooterComponent />
      </div>
    );
  }
}

export default translate("PartenaireComponent")(PartenaireComponent);



// WEBPACK FOOTER //
// ./src/components/Public/PartenairePage/PartenaireComponent.js